<template>
  <!-- Integrations.vue -->
  <div>
    <LoadingSpinner v-if="loading" />
    <section class="account" v-else>
      <div class="contenedor" v-if="!isCustomFields">
        <div class="card mt-3">
          <div class="body p-4 email-account">
            <div class="col-sm-12 pb-3">
              <button
                class="btn btn-sm btn-primary mb-4"
                v-if="user.role_id == 1"
                @click="openModal()"
              >
                CRM QUEUE
              </button>

              <Modal :name="'crmqueue'" class="p-4" scrollable="true">
                <div class="p-4">
                  <small
                    >* PENDING?: Hubspot ne nous laisse pas envoyer de
                    nombreuses requêtes en quelques secondes donc le système n'a
                    pas assez de temps pour tout envoyer et il y a beaucoup de
                    requêtes EN ATTENTE qui attendent d'être envoyées et elles
                    s'accumulent.</small
                  >

                  <div class="col-12">
        <template v-if="!graphsDataLoading">
          <div class="row mt-2">
            <div class="col-md-4" v-for="(item, label) in cardData">
              <div class="">
                <span class="card p-2 mb-2 text-center">
                  <h6>{{ $t("lang.column." + label) }}</h6>
                  <h4>{{ item[0].total }}</h4>
                </span>
              </div>
            </div>
            <div class="col-md-8">
              <div class="row">
                <div v-for="graph in graphsData" class="col-md-6">
                  <div class="p-2">
                    <doughnut-chart
                      class="py-2"
                      :chart-data="graph"
                      :options="graph.options"
                      :height="200"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <LoadingSpinner v-if="graphsDataLoading" />
      </div>

                  <div class="float-right">
                    <FilterSystem
                      class="float-right mr-2"
                      :columns="filterColumns"
                      :reset="resetFilterSystem"
                      :sort="sort"
                      :dir="dir"
                      :filterSystem="filtersDash"
                      :filterOldQuery="oldQuery"
                      :key="filterkey"
                      @callApi="filterNow($event)"
                    />
                  </div>
                  <Table
                    v-if="queue"
                    :key="3232323"
                    :headers="simpleheader"
                    :cols="simplecols"
                    :data="queue"
                    :checkbox="false"
                    :notselect="true"
                    :model="[]"
                  >
                  </Table>
                </div>
              </Modal>
              <h5 class="bold mb-4">
                {{ $t("lang.integrations.title") }}
              </h5>
              <span
                ><p class="font-weight-light">
                  {{ $t("lang.integrations.description") }}
                </p></span
              >
              <ul class="list-unstyled pl-4 pt-3">
                <li>
                  <i class="icon-check1 text-success mr-1"></i>
                  <span>{{ $t("lang.integrations.feature1") }}</span>
                </li>
                <li>
                  <i class="icon-check1 text-success mr-1"></i>
                  <span> {{ $t("lang.integrations.feature2") }} </span>
                </li>
                <li>
                  <i class="icon-check1 text-success mr-1"></i>
                  <span>{{ $t("lang.integrations.feature3") }}</span>
                </li>
              </ul>
              <div class="crm-list">
                <div class="row flex-row">
                  <div
                    class="col-sm-4 col-lg-3 panel text-center crm-item"
                    v-for="crmItem in crmList"
                    :key="crmItem.id"
                  >
                    <div
                      class="card shadow my-5"
                      :class="
                        !isCrmConfigSetted ||
                        crmConfig.crm_config_type_id == crmItem.id
                          ? ''
                          : 'disabled'
                      "
                    >
                      <div class="card-body">
                        <img
                          :src="require('@/assets/images/' + crmItem.logo)"
                          class="opp-logo br-30"
                        />
                        <h4 class="mt-2 mb-2">{{ crmItem.name }}</h4>

                        <div v-if="['2,3'].includes(user.plan_id)" class="mt-2">
                          <small>{{
                            $t("lang.label.upgradetounlockthisfeature")
                          }}</small>
                          <router-link
                            class="btn-primary btn-sm px-3 py-2 mr-4 ml-2 badge"
                            to="/upgrade"
                          >
                            <i class="icon icon-rocket"></i>
                            {{ $t("lang.button.upgrade") }}
                          </router-link>
                        </div>
                        <div v-else>
                          <div class="mb-3">
                            <b
                              v-if="crmConfig.crm_config_type_id == crmItem.id"
                            >
                              {{ crmConfig.email }}
                              <br />
                              {{ crmConfig.company_name }}
                            </b>
                          </div>
                          <div
                            v-if="crmConfig.crm_config_type_id == crmItem.id"
                          >
                            <div>
                              <button
                                class="btn btn-sm btn-success mt-2 w-100"
                                @click="goToCustomFields"
                              >
                                {{ $t("lang.integrations.configcustomfields") }}
                              </button>
                            </div>
                            <div>
                              <button
                                class="btn btn-sm btn-danger mt-2 w-100"
                                @click="deactivate"
                              >
                                {{ $t("lang.label.stopsyncing") }}
                              </button>
                            </div>
                          </div>
                          <a
                            class="btn btn-sm btn-primary btn-sm mb-3 mr-2"
                            :href="crmItem.href"
                            v-if="!isCrmConfigSetted"
                          >
                            {{ $t("lang.button.connect") }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <IntegrationsCustomFields
        v-if="isCustomFields"
        @hideCustomFields="hideCustomFields"
        :crmConfig="crmConfig"
      />
    </section>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { crmService } from "@/_services";
import Tutorial from "@/components/Tutorial.vue";
import IntegrationsCustomFields from "@/components/Account/IntegrationsCustomFields.vue";
import Modal from "@/components/Common/Modal.vue";
import Table from "@/components/Common/Table.vue";
import FilterSystem from "@/components/FilterSystem.vue";
import DoughnutChart from "@/components/DoughnutChart.vue";
export default {
  data() {
    return {
      filtersDash: {},
      graphsDataLoading: true,
      graphsData: [],
      cardData: {},
      sort: "",
      dir: "",
      oldQuery: "",
      resetFilterSystem: false,
      filterkey: 3444,
      filterColumns: [
        {
          name: "Date de création",
          name_: "date_creation",
          type: "date",
          field: "cq.created"
        },
        {
          name: "Email",
          name_: "email",
          type: "string",
          field: "u.email"
        },
        {
          name: "Statut",
          name_: "statut",
          type: "list",
          list: [
            { id: 1, name: "PENDING" },
            { id: 2, name: "PROCESSING" },
            { id: 3, name: "SENT" },
            { id: 5, name: "ERROR" }
          ],
          field: "cq.crm_queue_status_id"
        },
        {
          name: "Trigger",
          name_: "trigger",
          type: "string",
          field: "cq.trigger_event"
        },
        {
          name: "Client",
          name_: "client",
          type: "string",
          field: "cl.name"
        }
      ],
      loading: true,
      crmConfig: {},
      simpleheader: [
        {
          label: this.$t("lang.column.creationdate"),
          class: "overflowhide"
        },
        {
          label: this.$t("lang.column.client"),
          class: "overflowhide"
        },
        {
          label: this.$t("lang.column.email"),
          class: "overflowhide"
        },
        {
          label: this.$t("lang.column.status"),
          class: "overflowhide"
        },
        {
          label: "Trigger",
          class: "overflowhide"
        },
        {
          label: this.$t("lang.column.lastStatusUpdate"),
          class: "overflowhide"
        },
        {
          label: "log message"
        }
      ],
      simplecols: [
        [
          {
            value: "created",
            class: "text-primary"
          }
        ],
        [
          {
            value: "client_name",
            class: "text-primary"
          }
        ],
        [
          {
            value: "email",
            class: "text-primary"
          }
        ],
        [
          {
            label: "PENDING",
            value: "crm_queue_status_id",
            value_if: 1,
            type: "condition"
          },
          {
            label: "PROCESSING",
            value: "crm_queue_status_id",
            value_if: 2,
            type: "condition"
          },
          {
            label: "SENT",
            value: "crm_queue_status_id",
            value_if: 3,
            type: "condition"
          },
          {
            label: "ERROR",
            value: "crm_queue_status_id",
            value_if: 5,
            type: "condition"
          }
        ],
        [
          {
            value: "trigger_event",
            class: "text-primary"
          }
        ],
        [
          {
            value: "updated",
            class: "text-primary"
          }
        ],
        [
          {
            value: "response_message",
            class: "text-primary"
          }
        ]
      ],
      queue: false,
      isCustomFields: false,
      crmList: [
        {
          id: 1,
          name: "Pipedrive",
          logo: "pipedrive-logo.png",
          href:
            "https://oauth.pipedrive.com/oauth/authorize?response_type=code&client_id=ab536684e6ec88a6&redirect_uri=https://crm.oliverlist.com/1"
        },
        {
          id: 2,
          name: "Hubspot",
          logo: "hubspot-logo.png",
          href:
            "https://app.hubspot.com/oauth/authorize?client_id=459024f1-b968-4961-9f8f-d1833adc1521&redirect_uri=https://app.oliverlist.com/settings-account/integrations/2&scope=oauth%20crm.objects.contacts.read%20crm.objects.contacts.write%20crm.objects.companies.write%20crm.objects.companies.read%20crm.objects.deals.read%20crm.objects.deals.write%20conversations.visitor_identification.tokens.create%20conversations.write%20conversations.read%20crm.objects.custom.read%20crm.objects.custom.write"
        }
      ]
    };
  },

  components: {
    Header,
    LoadingSpinner,
    Tutorial,
    IntegrationsCustomFields,
    Modal,
    FilterSystem,
    Table,
    DoughnutChart
  },

  computed: {
    ...mapState({
      headerTab: state => state.header.tab
    }),

    user() {
      return this.$store.state.authentication.user;
    },

    isCrmConfigSetted() {
      return Object.keys(this.crmConfig).length > 0;
    }
  },

  created() {
    this.getCrmSettings();
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),

    openModal() {
      this.filterNow()
    },
    getCrmSettings() {
      this.loading = true;
      crmService
        .getConfig()
        .then(result => {
          if (result) {
            this.crmConfig = result;
            this.loading = false;
          }
        })
        .then(error => {
          this.loading = false;
        });
    },
    goToCustomFields() {
      this.isCustomFields = true;
    },
    hideCustomFields() {
      this.isCustomFields = false;
    },
    filterNow(filter) {
      if (filter != undefined) {
        this.filtersDash = filter;
        this.filtersDash.getGraphData = false;
      }
      crmService.getQueue(this.filtersDash).then(result => {
        this.queue = result;
        this.$modal.show("crmqueue");
        this.loadGraphs();
      });
    },
    loadGraphs() {
      this.graphsDataLoading = true;
      this.filtersDash.getGraphData = true;
      crmService.getQueue(this.filtersDash)
        .then((result) => {
          this.graphsData = [];
          this.cardData = {};
          Object.entries(result).forEach((value, index) => {
            if (value[1].graph_type != "pie") {
              this.cardData[value[0]] = value[1].data;
              return;
            }

            if (value[1].data[0].label == null) {
              return;
            }

            let graphsDataN = {
              labels: [],
              datasets: [{ data: [], backgroundColor: [] }],
              options: {
                cutoutPercentage: 10,
                responsive: true,
                aspectRatio: 1,
                maintainAspectRatio: false,
                devicePixelRatio: 2,
                title: {
                  display: true,
                  text: this.$t("lang.column." + value[0]),
                  innerText: "",
                },
                legend: {
                  display: false,
                },
              },
            };
            value[1].data.forEach((item, index2) => {
              graphsDataN.labels.push(item.label);
              var randomColor = Math.floor(Math.random() * 16777215).toString(
                16
              );
              graphsDataN.datasets[0].backgroundColor.push("#" + randomColor);
              graphsDataN.datasets[0].data.push(item.total);
            });
            this.graphsData.push(graphsDataN);
          });

          this.graphsDataLoading = false;
        });
      this.filtersDash.getGraphData = false;
    },

    deactivate() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.integrations.allsettingswillbedeleted"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes")
      }).then(result => {
        if (result.value) {
          crmService
            .deactivate()
            .then(result => {
              if (result) {
                this.crmConfig = result;
                this.loading = false;
              }
            })
            .then(error => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.crm-list .card {
  border: none;
  border-radius: 1rem;
  transition: all 0.2s;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
  height: 100%;
}
.crm-list .card.disabled:after {
  position: absolute;
  display: block;
  content: " ";
  background: rgba(46, 49, 49, 0.55);
  width: 100%;
  height: 100%;
  border-radius: 1rem;
}
</style>
